/** Minimal surface of Viewer needed to enter/leave the panel-drag edit mode. */
export interface IPanelDragViewer {
  startPanelDrag(id?: number): void;
  finishPanelDrag(): void;
}

/**
 * Enter "Edit (Measurement Result)" mode for one measurement
 * (SC_QUICK-2187, QU3DW-1367). Thin wrapper over `viewer.startPanelDrag`,
 * already implemented at the viewer layer (commit 249aaba1e) — panels are not
 * draggable by default (AC-1), only while this mode is active for the given
 * measurement id (AC-3, AC-4).
 */
export function startMeasurementResultEdit(
  viewer: IPanelDragViewer,
  id: number
): void {
  viewer.startPanelDrag(id);
}

/**
 * Leave "Edit (Measurement Result)" mode. Thin wrapper over
 * `viewer.finishPanelDrag` — after this call the panel is no longer
 * draggable and view controls (pan/rotate) are unaffected (AC-19).
 */
export function finishMeasurementResultEdit(viewer: IPanelDragViewer): void {
  viewer.finishPanelDrag();
}
